import { dayjs, getTimezone } from '../dates/dates';

export function transfromTimeslots(inputData, t) {
  const allData = [];
  for (let i = 0; i < inputData?.length; i++) {
    const day = inputData[i];
    const outputData = {
      dayIndex: i,
      day: returnDay(day.date, t),
      date: returnDate(day.date, t),
      timeslots: [],
      disabled: false,
    };
    let hasAvailable = false;
    for (let j = 0; j < day.timeslots.length; j++) {
      const timeslot = day.timeslots[j];
      const startsAt = timeslot.startsAt;
      const startsAtDate = timeslot.startsAtDate;
      const endsAt = timeslot.endsAt;
      const endsAtDate = timeslot.endsAtDate;
      const isAvailable =
        timeslot.isAvailable &&
        dayjs(timeslot.lastOrderBy).tz(getTimezone()).isAfter(dayjs(new Date()).tz(getTimezone()));
      if (isAvailable) hasAvailable = true;
      const timeslotName = `${startsAt}-${endsAt}`;
      const timeslotObject = {
        name: timeslotName,
        unavailable: !isAvailable,
        timeslotIndex: j,
        startsAt,
        endsAt,
        startsAtDate,
        endsAtDate,
      };

      outputData.timeslots.push(timeslotObject);
    }
    hasAvailable ? (outputData.disabled = false) : (outputData.disabled = true);
    allData.push(outputData);
  }
  return allData;
}

export function addDisabledDaysTimeslots(inputData, t) {
  const allData = [];
  for (let i = 0; i < inputData?.length; i++) {
    const day = inputData[i];
    const outputData = {
      date: day.date,
      timeslots: day.timeslots,
      disabled: false,
    };
    let hasAvailable = false;
    for (let j = 0; j < day.timeslots.length; j++) {
      const timeslot = day.timeslots[j];
      const isAvailable = timeslot.isAvailable;
      if (isAvailable) hasAvailable = true;
    }
    if (hasAvailable) {
      outputData.disabled = false;
    } else outputData.disabled = true;
    allData.push(outputData);
  }
  return allData;
}

export function isDateTomorrow(dateToCheck) {
  const checkDay = dayjs(dateToCheck).tz().startOf('day');
  const tomorrow = dayjs().tz().add(1, 'day').startOf('day');
  return checkDay.isSame(tomorrow);
}

export function returnDay(date, t) {
  const checkDay = dayjs.tz(date, 'YYYY-MM-DD', getTimezone()).startOf('day');
  const today = dayjs().tz().startOf('day');
  const tomorrow = today.add(1, 'day');

  if (checkDay.isSame(today)) return t('common.days.today');
  if (checkDay.isSame(tomorrow)) return t('common.days.tomorrow');

  const dayMap = {
    0: t('common.days.short_sunday'),
    1: t('common.days.short_monday'),
    2: t('common.days.short_tuesday'),
    3: t('common.days.short_wednesday'),
    4: t('common.days.short_thursday'),
    5: t('common.days.short_friday'),
    6: t('common.days.short_saturday'),
  };

  return dayMap[checkDay.day()];
}

export function daytToFull(day, t) {
  switch (day) {
    case t('common.days.short_monday'):
      return t('common.days.monday');
    case t('common.days.short_tuesday'):
      return t('common.days.short_tuesday');
    case t('common.days.short_wednesday'):
      return t('common.days.wednesday');
    case t('common.days.short_thursday'):
      return t('common.days.thursday');
    case t('common.days.short_friday'):
      return t('common.days.friday');
    case t('common.days.short_saturday'):
      return t('common.days.saturday');
    case t('common.days.short_sunday'):
      return t('common.days.sunday');
    default:
      return day;
  }
}

export function returnDate(date, t) {
  const format = process.env.dateFormat;
  const parts = format.split('/');
  parts.pop();
  return dayjs.tz(date, 'YYYY-MM-DD', getTimezone()).format(parts.join('/'));
}

export default { transfromTimeslots, returnDate, returnDay, daytToFull, addDisabledDaysTimeslots };
